function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGroupLogo = function SvgGroupLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "interit",
      height: "inherit"
    },
    viewBox: "0 0 565 30"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "group-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h150v30H0z",
    "data-name": "\\uC0AC\\uAC01\\uD615 6",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "group-logo_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h146v25H0z",
    "data-name": "\\uC0AC\\uAC01\\uD615 9",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "group-logo_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h169v25H0z",
    "data-name": "\\uC0AC\\uAC01\\uD615 10",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 15"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 14",
    style: {
      clipPath: "url(#group-logo_svg__a)"
    },
    transform: "translate(219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2 15A15.1 15.1 0 1 1 15.1 0a15.05 15.05 0 0 1 15.1 15",
    "data-name": "\\uD328\\uC2A4 43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.522 23.435h2.921l2.963 11.822 2.88-11.822h4.478v15.518h-2.835V26.424l-3.008 12.529h-3.072l-3.007-12.529v12.529h-2.835V25.479c0-.891.67-2.044 1.516-2.044",
    "data-name": "\\uD328\\uC2A4 44",
    style: {
      fill: "#f28c08"
    },
    transform: "translate(-96.657 -11.874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.284 23.434 5.279 15.518h-3.181l-.974-3.171h-5.69l-.975 3.171h-3.225l4.915-14.115c.216-.683.691-1.4 1.429-1.4zm-3.765 9.724h4.047l-2.034-6.6z",
    "data-name": "\\uD328\\uC2A4 45",
    style: {
      fill: "#f28c08"
    },
    transform: "translate(-113.527 -11.874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.115 23.435h1.494V36.1h7.185v2.854H257.6V25.479c0-.891.669-2.044 1.511-2.044",
    "data-name": "\\uD328\\uC2A4 46",
    style: {
      fill: "#f28c08"
    },
    transform: "translate(-129.679 -11.874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.045 23.435h1.493V36.1h7.186v2.854H281.53V25.479c0-.891.671-2.044 1.515-2.044",
    "data-name": "\\uD328\\uC2A4 47",
    style: {
      fill: "#f28c08"
    },
    transform: "translate(-141.724 -11.874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.979 47.128a1.432 1.432 0 1 0 1.433-1.421 1.43 1.43 0 0 0-1.433 1.421",
    "data-name": "\\uD328\\uC2A4 48",
    style: {
      fill: "#f28c08"
    },
    transform: "translate(-16.098 -23.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.285 23.968a3.04 3.04 0 0 1 .356-1.421H20a3.038 3.038 0 1 1-5.73 1.421 2.97 2.97 0 0 1 .647-1.856q-.012-.025-.022-.048L8.56 7.5H4.631a.8.8 0 1 1 0-1.6H9.09a.8.8 0 0 1 .737.483l.909 2.087h17.959A15.119 15.119 0 0 0 0 15a15.123 15.123 0 0 0 24.374 11.839 3.03 3.03 0 0 1-2.09-2.871",
    "data-name": "\\uD328\\uC2A4 49",
    style: {
      fill: "#00409c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.124 20.406h-1.635l-2.124 4.964.825 1.9z",
    "data-name": "\\uD328\\uC2A4 50",
    style: {
      fill: "#00409c"
    },
    transform: "translate(-13.776 -10.34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.982 47.128a1.433 1.433 0 1 0-1.434 1.423 1.43 1.43 0 0 0 1.434-1.423",
    "data-name": "\\uD328\\uC2A4 51",
    style: {
      fill: "#f28c08"
    },
    transform: "translate(-24.222 -23.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.037 20.615-3.627 8.591a.8.8 0 0 1-.744.491h-9.6l.735 1.7h9.165a3.05 3.05 0 0 1 2.75 1.726 14.94 14.94 0 0 0 1.323-12.5",
    "data-name": "\\uD328\\uC2A4 52",
    style: {
      fill: "#00409c"
    },
    transform: "translate(-15.638 -10.446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.929 27.99H33.6l3.242-7.585h-1.671z",
    "data-name": "\\uD328\\uC2A4 53",
    style: {
      fill: "#00409c"
    },
    transform: "translate(-16.073 -10.34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 23.339 1.253-2.933h-2.528z",
    "data-name": "\\uD328\\uC2A4 54",
    style: {
      fill: "#00409c"
    },
    transform: "translate(-11.591 -10.34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.781 20.406H49.1l-3.24 7.584h1.72z",
    "data-name": "\\uD328\\uC2A4 55",
    style: {
      fill: "#00409c"
    },
    transform: "translate(-23.086 -10.34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.81 27.99h1.75l3.24-7.584h-1.746z",
    "data-name": "\\uD328\\uC2A4 56",
    style: {
      fill: "#00409c"
    },
    transform: "translate(-19.537 -10.34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.332 23.434c-.735 0-1.212.72-1.429 1.4l-4.911 14.118h3.225l.971-3.171h5.694l.972 3.171h3.181l-5.28-15.518zm-1.343 9.724L70 26.562l2.034 6.6z",
    "data-name": "\\uD328\\uC2A4 57",
    style: {
      fill: "#00409c"
    },
    transform: "translate(-31.71 -11.874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.826 23.435h-4.239c-1.019.023-1.515.969-1.515 2.044v13.474h2.924V26.167h.039v-.019h2.792c2.727 0 3.638 1.943 3.638 5.045 0 3.262-.825 4.952-3.81 4.952h-1.29v2.807h.88a10.2 10.2 0 0 0 2.9-.321c2.834-.8 4.4-3.628 4.4-7.439 0-4.951-2.039-7.758-6.712-7.758",
    "data-name": "\\uD328\\uC2A4 58",
    style: {
      fill: "#00409c"
    },
    transform: "translate(-47.859 -11.874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.354 23.435h-5c-.846 0-1.514 1.153-1.514 2.044v13.474h3v-5.524h.018v-7.262h.025v-.04h3.072c1.407 0 2.12.753 2.12 2.26s-.537 2.257-2.055 2.236h-1.8v2.806h2.333c2.945 0 4.526-1.939 4.526-5 0-3.239-1.623-5-4.737-5",
    "data-name": "\\uD328\\uC2A4 59",
    style: {
      fill: "#00409c"
    },
    transform: "translate(-62.343 -11.874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.073 25.479v13.474h3.01V23.435h-1.5c-1.017 0-1.515.946-1.515 2.044",
    "data-name": "\\uD328\\uC2A4 60",
    style: {
      fill: "#00409c"
    },
    transform: "translate(-75.547 -11.874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.687 23.434h-2.423c-.734 0-1.211.72-1.427 1.4l-4.915 14.115h3.227l.975-3.171h5.69l.976 3.171h3.178zm-3.764 9.724 2.012-6.6 2.034 6.6z",
    "data-name": "\\uD328\\uC2A4 61",
    style: {
      fill: "#00409c"
    },
    transform: "translate(-80.505 -11.874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.537 6.225a1.5 1.5 0 0 1-.1.552 1.3 1.3 0 0 1-.287.45 1.35 1.35 0 0 1-.46.3 1.75 1.75 0 0 1-1.222 0 1.4 1.4 0 0 1-.46-.3 1.3 1.3 0 0 1-.287-.45 1.6 1.6 0 0 1 0-1.1 1.3 1.3 0 0 1 .287-.452 1.3 1.3 0 0 1 .46-.3 1.74 1.74 0 0 1 1.222 0 1.3 1.3 0 0 1 .747.754 1.5 1.5 0 0 1 .1.552m-.68 0a1 1 0 0 0-.053-.317.8.8 0 0 0-.15-.266.7.7 0 0 0-.244-.184.8.8 0 0 0-.33-.067.8.8 0 0 0-.331.067.7.7 0 0 0-.243.184.8.8 0 0 0-.151.266.98.98 0 0 0 0 .631.8.8 0 0 0 .151.266.7.7 0 0 0 .243.184.8.8 0 0 0 .331.069.8.8 0 0 0 .33-.069.7.7 0 0 0 .244-.184.8.8 0 0 0 .15-.266 1 1 0 0 0 .053-.315m-.388 4.027a.45.45 0 0 1-.238-.085A1.3 1.3 0 0 1 72 9.977a1.2 1.2 0 0 1-.167-.208.4.4 0 0 1-.075-.2V8.248h.685v1.208q0 .201.192.2h2.605q.148 0 .148.3a.5.5 0 0 1-.04.227.12.12 0 0 1-.108.067zm2.8-1.833q-.001.08-.1.111a1 1 0 0 1-.247.03q-.334 0-.333-.141V4.667h.685z",
    "data-name": "\\uD328\\uC2A4 62",
    style: {
      fill: "#717071"
    },
    transform: "translate(-35.552 -2.365)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.285 7.7a3 3 0 0 1-.306-.257 3 3 0 0 1-.281-.314 3 3 0 0 1-.237-.349 2 2 0 0 1-.169-.368 2 2 0 0 1-.177.386 3 3 0 0 1-.259.376 4 4 0 0 1-.3.335 2.4 2.4 0 0 1-.3.257.1.1 0 0 1-.121.01.7.7 0 0 1-.163-.163 1.2 1.2 0 0 1-.12-.175.08.08 0 0 1 .027-.112 4 4 0 0 0 .547-.554 2.4 2.4 0 0 0 .366-.618 2 2 0 0 0 .106-.4 3 3 0 0 0 .031-.464v-.222h.715V5.3a4 4 0 0 0 .022.421 1.7 1.7 0 0 0 .089.395 2.4 2.4 0 0 0 .336.619 3.7 3.7 0 0 0 .534.57.09.09 0 0 1 .043.1.6.6 0 0 1-.111.167 1 1 0 0 1-.151.152q-.046.03-.114-.018m-2.383 1.709v-.594h1.03v-1.25h.686v1.25h.982q.149 0 .147.3c-.002.3-.049.294-.147.294zm4.32-4.623h.679v5.047q0 .141-.34.141c-.34 0-.339-.047-.339-.141v-2.6h-.574v2.538a.12.12 0 0 1-.077.1.7.7 0 0 1-.257.037q-.34 0-.339-.141v-4.92h.672v1.791h.574z",
    "data-name": "\\uD328\\uC2A4 63",
    style: {
      fill: "#717071"
    },
    transform: "translate(-40.691 -2.428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.925 7.986V7.4h5.16c.095 0 .141.1.141.29a.5.5 0 0 1-.037.229.11.11 0 0 1-.1.07zm1.482 2.323a.45.45 0 0 1-.238-.085 1.3 1.3 0 0 1-.23-.189 1.3 1.3 0 0 1-.168-.208.4.4 0 0 1-.074-.2V8.392h.685v1.121q0 .201.192.2h2.734q.148 0 .148.3a.5.5 0 0 1-.04.227.12.12 0 0 1-.108.067zm.024-3.438a.44.44 0 0 1-.237-.087 1.3 1.3 0 0 1-.232-.19 1.2 1.2 0 0 1-.166-.208.4.4 0 0 1-.074-.2V4.78h.685v1.293a.22.22 0 0 0 .043.154.19.19 0 0 0 .148.048h2.648q.149 0 .148.3c-.001.3-.049.295-.148.295z",
    "data-name": "\\uD328\\uC2A4 64",
    style: {
      fill: "#717071"
    },
    transform: "translate(-46.275 -2.422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11 7.939h.686v1.22h1.412q.15 0 .149.3c-.001.3-.05.294-.149.294h-5.153v-.594h1.545v-1.22h.685v1.22h.827zm1.414.153a4.7 4.7 0 0 1-1.022-.556 4 4 0 0 1-.462-.389 1.8 1.8 0 0 1-.336-.435 2.1 2.1 0 0 1-.334.429 4 4 0 0 1-.462.405 6 6 0 0 1-.519.349 4 4 0 0 1-.493.258.1.1 0 0 1-.123-.031 2 2 0 0 1-.142-.184.7.7 0 0 1-.114-.209.08.08 0 0 1 .046-.1 7.4 7.4 0 0 0 .944-.576 2.3 2.3 0 0 0 .6-.607 1.05 1.05 0 0 0 .173-.407 2.5 2.5 0 0 0 .031-.384v-.317h.74v.343a2 2 0 0 0 .031.375 1.1 1.1 0 0 0 .179.392 1.8 1.8 0 0 0 .291.328 4 4 0 0 0 .385.309 5 5 0 0 0 .431.277q.226.128.43.221a.08.08 0 0 1 .055.094.8.8 0 0 1-.093.206 1 1 0 0 1-.12.186.09.09 0 0 1-.114.023",
    "data-name": "\\uD328\\uC2A4 65",
    style: {
      fill: "#717071"
    },
    transform: "translate(-53.389 -2.705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.551 4.809q.149 0 .148.3c-.001.3-.049.294-.148.294h-.463v1.386h.648q.148 0 .147.3c-.001.3-.048.288-.147.288h-3.419v-.588h.587V5.4h-.587v-.591zM119.4 5.4h-.815v1.389h.815zm2.346 3.71a1.3 1.3 0 0 1-.114.549 1.3 1.3 0 0 1-.315.423 1.5 1.5 0 0 1-.469.269 1.8 1.8 0 0 1-1.154 0 1.4 1.4 0 0 1-.469-.269 1.2 1.2 0 0 1-.315-.423 1.38 1.38 0 0 1 0-1.1 1.24 1.24 0 0 1 .315-.424 1.5 1.5 0 0 1 .469-.269 1.8 1.8 0 0 1 1.154 0 1.5 1.5 0 0 1 .469.269 1.3 1.3 0 0 1 .315.424 1.3 1.3 0 0 1 .114.549m-2.272 0a.73.73 0 0 0 .214.539.9.9 0 0 0 1.166 0 .79.79 0 0 0 0-1.078.9.9 0 0 0-1.166 0 .73.73 0 0 0-.214.539m2.42-1.533q0 .08-.1.11a.8.8 0 0 1-.244.031q-.339 0-.339-.141V4.668h.685z",
    "data-name": "\\uD328\\uC2A4 66",
    style: {
      fill: "#717071"
    },
    transform: "translate(-59.058 -2.365)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.868 6.84a1.7 1.7 0 0 1 .118-.653 1.4 1.4 0 0 1 .326-.495 1.5 1.5 0 0 1 .5-.312 1.9 1.9 0 0 1 1.272 0 1.5 1.5 0 0 1 .5.312 1.4 1.4 0 0 1 .327.495 1.88 1.88 0 0 1 0 1.306 1.4 1.4 0 0 1-.327.493 1.45 1.45 0 0 1-.5.312 1.88 1.88 0 0 1-1.272 0 1.5 1.5 0 0 1-.5-.312 1.4 1.4 0 0 1-.326-.493 1.7 1.7 0 0 1-.118-.653m2.481 0a.98.98 0 0 0-.254-.717.94.94 0 0 0-1.3 0 .98.98 0 0 0-.253.717.98.98 0 0 0 .253.717.94.94 0 0 0 1.3 0 .98.98 0 0 0 .254-.717m2.1 3q0 .073-.1.107a.7.7 0 0 1-.245.035.8.8 0 0 1-.247-.035q-.1-.034-.1-.107V4.791h.685z",
    "data-name": "\\uD328\\uC2A4 67",
    style: {
      fill: "#717071"
    },
    transform: "translate(-64.369 -2.428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.279 8.661a.45.45 0 0 1-.238-.085 1.3 1.3 0 0 1-.233-.19 1.2 1.2 0 0 1-.166-.209.4.4 0 0 1-.073-.2V5.215h2.631q.149 0 .148.3c-.001.3-.05.294-.148.294h-1.951v2.055a.22.22 0 0 0 .043.152.2.2 0 0 0 .148.05h2.1q.149 0 .148.3c-.001.3-.049.294-.148.294zm2.938-3.869h.685v1.79h.907v.595h-.909v2.662q0 .078-.1.11a.8.8 0 0 1-.244.032q-.338 0-.339-.141z",
    "data-name": "\\uD328\\uC2A4 68",
    style: {
      fill: "#717071"
    },
    transform: "translate(-69.756 -2.428)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 19"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 18",
    style: {
      clipPath: "url(#group-logo_svg__b)"
    },
    transform: "translate(419 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.295 20.331C11.183 16.568 2.022 10.07 3.629 5.4 4.951 1.563 12.078.244 20.808 1.778c.47-.1 1.046-.211 1.622-.317C11.154-1.176 1.722-.215.207 4.116c-1.714 4.906 7.359 12.323 20.416 16.819z",
    "data-name": "\\uD328\\uC2A4 85",
    style: {
      fill: "#00347d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.578 6.541.036-.014-.567-.248a7 7 0 0 0-.277-.134l-.006.01C34.973 5.377 33.341 4.8 33.341 4.8l-1.751.383a24.3 24.3 0 0 1 4 1.643c6.977 3.715 12.287 9.275 11.05 12.841-1.067 3.108-5.965 4.565-12.437 4.188a10 10 0 0 1-1.8.641c9.5 1.594 17.008.387 18.354-3.442 1.36-3.889-4.347-10.135-13.184-14.511",
    "data-name": "\\uD328\\uC2A4 86",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-.101 -.18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.494 12.533c-6.623-3.849-7.981-4.043-5.626-6.107a22.1 22.1 0 0 0-5.695 6.388s5.592 2.734 7.719 4.655a2.78 2.78 0 0 1 .727 2.415c-.441 1.561-2.236 3.261-7 3.283 0 0 6.973 1.841 11.477-.108s5.017-6.679-1.6-10.526",
    "data-name": "\\uD328\\uC2A4 87",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-.064 -.241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.863 1.564 23.43.887l3.534 1.254a29.9 29.9 0 0 0-12.647 7.238l2.064 1.146c3.283-3.836 9.22-8.19 19.482-8.961",
    "data-name": "\\uD328\\uC2A4 88",
    style: {
      fill: "#f38200"
    },
    transform: "translate(-.046 -.034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.829 10.816 2.814 1.558a20 20 0 0 1 1.979-2.842 22.27 22.27 0 0 1 13.055-7.464c-5.048.535-12.631 2.438-17.848 8.748",
    "data-name": "\\uD328\\uC2A4 89",
    style: {
      fill: "#f38200"
    },
    transform: "translate(-.054 -.078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.675 4.468v.013a1.159 1.159 0 0 0 0 2.312V6.8h1.66v3.563h-1.66v.008a1.16 1.16 0 0 0 0 2.313v.01h13.1v-2.33h-2.853V6.8h2.853V4.468zm7.833 5.9h-3.753V6.8h3.753z",
    "data-name": "\\uD328\\uC2A4 90",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-.301 -.167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.656 16.884v.016a1.117 1.117 0 0 0 0 2.228v.014h15.222v-2.258z",
    "data-name": "\\uD328\\uC2A4 91",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-.355 -.632)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.631 13.439h11.144v-2.254h-10.909a.77.77 0 0 1-.817-.786V7.3a.773.773 0 0 1 .817-.788h10.909V4.26h-11.144a2.864 2.864 0 0 0-2.914 2.819v3.547a2.865 2.865 0 0 0 2.914 2.814",
    "data-name": "\\uD328\\uC2A4 92",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-.359 -.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.862 14.883h-3.245v1.949h3.245v2.259h-8.741a.765.765 0 0 1-.809-.781v-2.7h-2.327v2.92a2.86 2.86 0 0 0 2.9 2.805h8.985l2.321-2.244V4.279h-2.329z",
    "data-name": "\\uD328\\uC2A4 93",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-.245 -.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.429 7.634c0 2.137 2.428 3.87 5.419 3.87s5.42-1.733 5.42-3.87-2.427-3.866-5.42-3.866-5.419 1.732-5.419 3.866m8.377 0c0 1.032-1.327 1.879-2.959 1.879s-2.96-.847-2.96-1.879 1.329-1.871 2.96-1.871 2.959.841 2.959 1.871",
    "data-name": "\\uD328\\uC2A4 94",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-.243 -.141)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.038 17.412h2.322v-3.291h4.108V12.1H76.782a1.087 1.087 0 0 0-1.158 1.01 1.1 1.1 0 0 0 1.158 1.009h4.255z",
    "data-name": "\\uD328\\uC2A4 95",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-.241 -.453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.03 10.487a4.2 4.2 0 0 1-2.672-1.832c-.949-1.421-.876-3.282-.888-4.555h-2.417c-.012 1.274.059 3.134-.891 4.555a4.3 4.3 0 0 1-2.668 1.905 1.28 1.28 0 0 0-.874 1.183 1.1 1.1 0 0 0 1.16 1.03 1.4 1.4 0 0 0 .219-.02 1 1 0 0 1 .108-.025 6.3 6.3 0 0 0 1.682-.649 7.34 7.34 0 0 0 2.438-2.344c.008-.013.035-.049.035-.049v.007c.01.019.028.03.035.042A7.1 7.1 0 0 0 65.734 12a6.2 6.2 0 0 0 1.681.651c.04 0 .072.022.111.024a1.3 1.3 0 0 0 .215.021 1.1 1.1 0 0 0 1.159-1.032 1.27 1.27 0 0 0-.87-1.177",
    "data-name": "\\uD328\\uC2A4 96",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-.183 -.154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.616 4.26h-2.371v2.974h-3.95V9.21h3.95v4.953a9.7 9.7 0 0 0-3.882-.95c-2.822 0-6.136 1.764-6.136 4.374s3.314 4.376 6.136 4.376S73.5 20.2 73.5 17.586a3.72 3.72 0 0 0-1.159-2.718l1.276-1.106zm-6.14 15.42c-1.5 0-3.732-.775-3.732-2.152s2.236-2.156 3.732-2.156 3.732.774 3.732 2.156-2.238 2.152-3.732 2.152",
    "data-name": "\\uD328\\uC2A4 97",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-.195 -.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.246 14.281v.013a1.156 1.156 0 0 0 0 2.306v.013h6.219v5.771l2.422-1.778v-3.992h7.236v-2.333z",
    "data-name": "\\uD328\\uC2A4 98",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-.296 -.534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.154 11.581v-1.316h4.98v-6.5h-12.4v3.792a2.52 2.52 0 0 0 .813 1.982 3.08 3.08 0 0 0 2.134.726h2.073v1.316h-6.346a1 1 0 0 0-.994.976.96.96 0 0 0 .335.725 1.1 1.1 0 0 0 .659.257h16v-1.958zM135.028 8.3a1.06 1.06 0 0 1-.671-.167.74.74 0 0 1-.2-.6V5.731h7.561V8.3z",
    "data-name": "\\uD328\\uC2A4 99",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-.412 -.141)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.385 20.047v-.51h9.534v-4.574h-11.952v1.845h9.533v.884h-9.533v2.158c0 .075.015.141.021.213l2.355 2.265a4 4 0 0 0 .45.035h9.736v-1.846h-9.472q-.671 0-.672-.471",
    "data-name": "\\uD328\\uC2A4 100",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-.42 -.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 21"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 20",
    style: {
      clipPath: "url(#group-logo_svg__c)"
    },
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.314 20.33C11.193 16.567 2.024 10.069 3.633 5.4 4.956 1.563 12.089.243 20.825 1.777c.472-.1 1.047-.21 1.624-.316C11.164-1.177 1.723-.215.208 4.115-1.508 9.021 7.572 16.439 20.64 20.934z",
    "data-name": "\\uD328\\uC2A4 101",
    style: {
      fill: "#00347d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.9 12.21.037-.015c-.194-.083-.379-.165-.568-.248a9 9 0 0 0-.277-.134l-.006.009c-1.792-.778-3.425-1.356-3.425-1.356l-1.754.383a24.4 24.4 0 0 1 4.007 1.644c6.982 3.714 12.3 9.274 11.059 12.841C82.9 28.442 78 29.9 71.524 29.522a10 10 0 0 1-1.8.641c9.508 1.594 17.021.387 18.369-3.443 1.36-3.889-4.351-10.134-13.2-14.511",
    "data-name": "\\uD328\\uC2A4 102",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-37.39 -5.848)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.333 20.122c-6.629-3.849-7.988-4.042-5.63-6.107A22.1 22.1 0 0 0 44 20.4s5.6 2.733 7.726 4.654a2.78 2.78 0 0 1 .727 2.415c-.44 1.562-2.237 3.262-7.007 3.283 0 0 6.978 1.842 11.487-.108s5.021-6.679-1.6-10.526",
    "data-name": "\\uD328\\uC2A4 103",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-23.877 -7.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.793 2.613 40.35 1.936l3.536 1.254a29.9 29.9 0 0 0-12.657 7.238l2.071 1.146c3.285-3.837 9.227-8.19 19.5-8.961",
    "data-name": "\\uD328\\uC2A4 104",
    style: {
      fill: "#f38200"
    },
    transform: "translate(-16.946 -1.081)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.708 13.259 2.816 1.558a20 20 0 0 1 1.98-2.842 22.3 22.3 0 0 1 13.067-7.463c-5.053.534-12.641 2.438-17.863 8.747",
    "data-name": "\\uD328\\uC2A4 105",
    style: {
      fill: "#f38200"
    },
    transform: "translate(-19.919 -2.521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.63 15.286h-1.091v-4.651h-2.272v18.021l2.272-1.8v-9.479h1.091v11.28l2.35-1.8V10.635h-2.35z",
    "data-name": "\\uD328\\uC2A4 106",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-125.492 -5.941)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.517 39.58v.012a1.174 1.174 0 0 0 0 2.342v.015h16.015V39.58z",
    "data-name": "\\uD328\\uC2A4 107",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-134.805 -22.113)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.638 28.656 2.463-1.8V10.635h-2.463z",
    "data-name": "\\uD328\\uC2A4 108",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-173.987 -5.941)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.331 15.286v-4.651h-2.466v18.019l2.466-1.807v-9.47h2.856v-2.091z",
    "data-name": "\\uD328\\uC2A4 109",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-194.188 -5.941)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.366 10.914v.012a1.175 1.175 0 0 0 0 2.344v.011h1.321v7.429h-1.321v.008a1.175 1.175 0 0 0 0 2.345v.01H302.2V20.71h-2.018v-7.428h2.018v-2.368zm7.362 9.8h-3.585v-7.432h3.585z",
    "data-name": "\\uD328\\uC2A4 110",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-156.969 -6.097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.456 10.635a6.01 6.01 0 0 0-5.789 6.206 5.8 5.8 0 1 0 11.582 0 6.01 6.01 0 0 0-5.794-6.206m0 9.866a3.5 3.5 0 0 1-3.307-3.659 3.326 3.326 0 1 1 6.619 0 3.51 3.51 0 0 1-3.312 3.659",
    "data-name": "\\uD328\\uC2A4 111",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-178.886 -5.942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.314 10.635c-3.031 0-5.481 2.779-5.481 6.206s2.45 6.2 5.481 6.2 5.479-2.777 5.479-6.2-2.453-6.206-5.479-6.206m0 9.866c-1.677 0-3.047-1.646-3.047-3.659s1.37-3.663 3.047-3.663 3.043 1.646 3.043 3.663-1.368 3.659-3.043 3.659",
    "data-name": "\\uD328\\uC2A4 112",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-111.148 -5.942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 20.284h11.724v-2.369h-11.472a.81.81 0 0 1-.859-.827v-3.254a.81.81 0 0 1 .859-.828h11.477v-2.371H254a3.013 3.013 0 0 0-3.06 2.965v3.728a3.01 3.01 0 0 0 3.06 2.956",
    "data-name": "\\uD328\\uC2A4 113",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-136.167 -5.942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.977 21.824h-3.413v2.049h3.413v2.374h-9.2a.8.8 0 0 1-.852-.82v-2.838h-2.448v3.07a3.006 3.006 0 0 0 3.053 2.948h9.452l2.441-2.359v-15.57h-2.45z",
    "data-name": "\\uD328\\uC2A4 114",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-91.423 -5.966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.033 16.982a4.42 4.42 0 0 1-2.811-1.926c-1-1.493-.922-3.45-.935-4.787h-2.542c-.012 1.338.062 3.294-.937 4.787a4.54 4.54 0 0 1-2.808 2 1.35 1.35 0 0 0-.919 1.243 1.16 1.16 0 0 0 1.221 1.083 1.4 1.4 0 0 0 .231-.022c.037-.008.076-.02.113-.026a6.6 6.6 0 0 0 1.769-.682 7.7 7.7 0 0 0 2.565-2.463l.037-.052v.007c.01.02.029.031.037.045a7.45 7.45 0 0 0 2.562 2.38 6.6 6.6 0 0 0 1.768.683c.042 0 .076.023.116.026a1.4 1.4 0 0 0 .227.023 1.16 1.16 0 0 0 1.219-1.084 1.34 1.34 0 0 0-.915-1.237",
    "data-name": "\\uD328\\uC2A4 115",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-67.33 -5.737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.207 13.571c0 2.246 2.554 4.067 5.7 4.067s5.7-1.821 5.7-4.067-2.554-4.063-5.7-4.063-5.7 1.818-5.7 4.063m8.813 0c0 1.085-1.4 1.976-3.113 1.976s-3.113-.891-3.113-1.976 1.4-1.967 3.113-1.967 3.113.884 3.113 1.967",
    "data-name": "\\uD328\\uC2A4 116",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-90.731 -5.312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.057 34.2h2.443v-3.463h4.321v-2.121h-11.24a1.071 1.071 0 1 0 0 2.121h4.476z",
    "data-name": "\\uD328\\uC2A4 117",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-89.73 -15.988)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.387 10.634h-2.494v3.126h-4.157v2.077h4.157v5.205a10.3 10.3 0 0 0-4.084-1c-2.969 0-6.455 1.854-6.455 4.6s3.487 4.6 6.455 4.6 6.456-1.856 6.456-4.6a3.9 3.9 0 0 0-1.22-2.858l1.342-1.162zm-6.46 16.208c-1.575 0-3.927-.814-3.927-2.263s2.352-2.266 3.927-2.266 3.927.814 3.927 2.266-2.355 2.263-3.927 2.263",
    "data-name": "\\uD328\\uC2A4 118",
    style: {
      fill: "#00347d"
    },
    transform: "translate(-71.818 -5.941)"
  }))));
};
export default SvgGroupLogo;